import React from "react";
import Modal from "./Modal";

// Help modal that lists all global keyboard shortcuts. Opens via `?` or
// the "Keyboard shortcuts" command-palette entry. Mirror what's wired in
// AppShell's useKeyboardShortcuts call.
const SECTIONS = [
  {
    heading: "Global",
    rows: [
      { keys: ["⌘", "K"],    desc: "Open command palette" },
      { keys: ["?"],         desc: "Show this shortcuts list" },
      { keys: ["Esc"],       desc: "Close any open dialog / palette" },
    ],
  },
  {
    heading: "Jump to",
    rows: [
      { keys: ["g", "d"],    desc: "Dashboard" },
      { keys: ["g", "j"],    desc: "Jobs" },
      { keys: ["g", "i"],    desc: "Interviews" },
      { keys: ["g", "c"],    desc: "Compare" },
      { keys: ["g", "p"],    desc: "Pipeline" },
      { keys: ["g", "s"],    desc: "Source hub" },
      { keys: ["g", "t"],    desc: "Talent pools" },
      { keys: ["g", "a"],    desc: "Analytics" },
    ],
  },
  {
    heading: "Create",
    rows: [
      { keys: ["n", "j"],    desc: "New job" },
      { keys: ["n", "c"],    desc: "Invite candidate" },
    ],
  },
];

export default function ShortcutsModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" size="md">
      <div className="grid grid-cols-1 gap-5">
        {SECTIONS.map((s) => (
          <section key={s.heading}>
            <h3 className="text-2xs uppercase tracking-wide text-vf-muted font-semibold mb-2">
              {s.heading}
            </h3>
            <dl className="grid grid-cols-1 gap-1.5">
              {s.rows.map((r) => (
                <div key={r.desc} className="flex items-center justify-between gap-3 py-1">
                  <dt className="text-sm text-vf-base">{r.desc}</dt>
                  <dd className="flex gap-1 m-0">
                    {r.keys.map((k, i) => (
                      <kbd
                        key={`${r.desc}-${i}`}
                        className="text-2xs font-mono bg-vf-tint border border-subtle rounded px-2 py-1 text-vf-base"
                      >
                        {k}
                      </kbd>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
      <p className="text-2xs text-vf-muted mt-5">
        Shortcuts are skipped while you're typing in a text field. Hold ⌘/Ctrl for
        OS shortcuts as usual.
      </p>
    </Modal>
  );
}
